export function getRouteKey(key = 'path', route) {
    if (key === false || key === 'route') {
        return route.name
    }
    if (key === 'path') {
        return route.path
    }
    if (key === 'path&query' || key === 'route&query') {
        let search = route.fullPath.split('?')[1] || ''
        search = search.split('#')[0]
        if (key === 'path&query') {
            return `${route.path}?${search}`
        }
        if (key === 'route&query') {
            return `${route.name}?${search}`
        }
    }
    return key
}
